import { Token } from 'config/types'
import { ChainIdEnum } from '../network'

const path = '/images/token'

const tokens: Record<string, Token> = {
  S: {
    coinGeckoInfo: {
      id: 'sonic-3',
    },
    logo: `${path}/s.png`,
    name: 'S',
    code: 'S',
    network: ChainIdEnum.SONIC,
    decimals: 18,
    isNative: true,
  },
  USDC: {
    coinGeckoInfo: {
      id: 'usd-coin',
    },
    logo: `${path}/usdc.png`,
    name: 'USDC',
    code: 'USDC',
    network: ChainIdEnum.SONIC,
    address: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
    decimals: 6,
    isStable: true,
  },
}

export default tokens
